import { put, call, takeLatest, select } from "redux-saga/effects";
import * as Api from "../api";
import * as AdminApi from "../../AdminPanel/api";
import * as ActionConstants from "../actions/actionConstants";
import { HIDE_DIALOGUE_BOX } from "../../../components/DialogueBox/actionConstants";
import { updatePanelDataPermissionSet } from '../../WorkkardDetail/Saga/middlePanelContainer';
import * as WorkkardErrorConstant from '../../WorkkardDetail//errorConstant';
import { logout } from '../../WorkkardDetail/Saga/common';
import {LOG_APPLICATON_ERROR, BUTTON_LOADER} from "../../..//containers/WorkkardDetail/actions/actionConstants";
import {  ErrorCode } from '../../WorkkardDetail/constants';
import  * as PUBLIC_API_PARTY  from "../../../publicApiActions/partyActions";
import { SHOW_TOAST_WITH_PROPS} from '../../../common/actionConstants';
import {getAxiosError } from '../../../common/util';
import { partyPhoneTypes, partySourceList } from "../../../common/constants";
import { savePartySuccess, savePartyFailure } from "../../AdminPanel/features/parties/partiesSlice";


export function* fetchAssocitedPartiesData({payload}) {
    try{
        yield put({ type: ActionConstants.SHOW_PARTIES_LOADER });
        const associatedParties =yield call(Api.getAssociatedParties,ActionConstants.FETCH_ASSOCIATED_PARTIES_DATA_REQUEST,payload);
        
        if(associatedParties.status==200){
            yield put({type: ActionConstants.RESET_ASSOCIATED_PARTIES})
            yield put ({
                type: ActionConstants.FETCH_ASSOCIATED_PARTIES_DATA_SUCCESS,
                payload:{...associatedParties,skip:payload.skip,take:payload.take,activeTab:payload.activeTab} 
            })
            yield put({
                type: ActionConstants.SET_PARTY_ASSOCIATION,
                payload: payload.type
            })
        }
        else if(associatedParties.status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status:associatedParties.status, isErrorScreen:false  }
            });
        }
    }
    catch(error){

    }
    finally{
        yield put({ type: ActionConstants.HIDE_PARTIES_LOADER });
    }
}

export function* updateAssocitedPartiesData({payload}) {
    try{
        yield put({ type: ActionConstants.SHOW_PARTIES_LOADER });
        const associatedParties =yield call(Api.getAssociatedParties,ActionConstants.FETCH_ASSOCIATED_PARTIES_DATA_REQUEST,payload);
        
        if(associatedParties.status==200){
            yield put ({
                type: ActionConstants.UPDATE_ASSOCIATED_PARTIES_DATA_SUCCESS,
                payload:{...associatedParties,skip:payload.skip,take:payload.take,activeTab:payload.activeTab}
            })
        }
        else if(associatedParties.status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status:associatedParties.status, isErrorScreen:false  }
            });
        }
    }
    catch(error){

    }
    finally{
        yield put({ type: ActionConstants.HIDE_PARTIES_LOADER });
    }
}

export function* updateContactRelationshipType({payload}) {
    try{
        yield put({ type: BUTTON_LOADER, payload: { contactRelationType: true}});
        const { callback} =  payload;
        delete payload.callback;
        const associatedParties =yield call(Api.updateContactRelationshipType,ActionConstants.UPDATE_CONTACT_RELATIONSHIP_REQUEST,payload);
        
        if(associatedParties.status==200){
            callback(true);
        }
        else if(associatedParties.status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status:associatedParties.status, isErrorScreen:false  }
            });
        }
    }
    catch(error){

    }
    finally{
        yield put({ type: BUTTON_LOADER, payload: { contactRelationType: false}});
    }
}

export function* fetchCarrierList({payload}){
    try {
        const fetchCarrierList = yield call(Api.fetchCarrierList, ActionConstants.FETCH_CARRIER_LIST, payload);
        if(fetchCarrierList) {
            const payload = {
                carrierList: fetchCarrierList?.results,
            }            
            yield put ({
                type: ActionConstants.FETCH_CARRIER_LIST_SUCCESS,
                payload
            });
        }
    }
    catch(error){
        console.error("API Error:", error);
    }
    finally{}
}

export function* fetchCreatePartyData({payload}) {
    try{
        yield put({ type: ActionConstants.SHOW_PARTIES_LOADER });
        const createPartyData = yield call(
            Api.fetchCreatePartyData, 
            ActionConstants.FETCH_CREATE_PARTY_DATA_REQUEST, 
            payload
        );
        if(createPartyData){
            const payload = {
                partyEntityTypes: createPartyData?.entity_types,
                partyTypes: createPartyData?.party_types,
                partyRelationTypes: createPartyData?.relationship_types,
                partyPhoneTypes: partyPhoneTypes,
                partySourceList: partySourceList
                // partyCarrierList: JSON.parse(createPartyData.Data.party_carrier_list),
                // partyCountryList: JSON.parse(createPartyData.Data.party_countries),
            }            
            yield put ({
                type: ActionConstants.FETCH_CREATE_PARTY_DATA_SUCCESS,
                payload
            })
        }
    }
    catch(error){
        console.error("API Error:", error);
    }
    finally{
        yield put({ type: ActionConstants.HIDE_PARTIES_LOADER });
    }
}

export function* fetchPartyInfo({payload}) {
    try{
        yield put({ type: ActionConstants.SHOW_PARTIES_LOADER });
        const partyInfo = yield call(Api.fetchPartyInfo, ActionConstants.FETCH_PARTY_INFO_REQUEST, payload);
        if(partyInfo.status == 200){
            // yield put({type: ActionConstants.RESET_ASSOCIATED_PARTIES})
            yield put ({
                type: ActionConstants.FETCH_PARTY_INFO_SUCCESS,
                payload: partyInfo.Data
            })
        }
        else if(partyInfo.status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status:partyInfo.status, isErrorScreen:false  }
            });
        }
    }
    catch(error){

    }
    finally{
        yield put({ type: ActionConstants.HIDE_PARTIES_LOADER });
    }
}

export function* fetchPartyStates({payload}) {
    try{
        let callback;
        if(payload.hasOwnProperty("callback"))
        {
             callback = payload.callback;
             delete payload.callback;
        }
        yield put({ type: ActionConstants.SHOW_PARTIES_LOADER });
        const partyStates = yield call(Api.fetchPartyStates, ActionConstants.FETCH_PARTY_STATES_REQUEST, payload);
        if(partyStates.status == 200){
            yield put ({
                type: ActionConstants.FETCH_PARTY_STATES_SUCCESS,
                payload: partyStates.Data,
                listType: payload.listType
            })
            if(callback)
            {
             callback({listType:payload.listType, states: partyStates.Data})
            } 
        }
        else if(partyStates.status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status:partyStates.status, isErrorScreen:false  }
            });
        }
    }
    catch(error){

    }
    finally{
        yield put({ type: ActionConstants.HIDE_PARTIES_LOADER });
    }
}

export function* fetchPartySuggestions({payload}) {
    try{
        const response = yield call(Api.fetchPartySuggestions, ActionConstants.FETCH_PARTY_SUGGESTION_REQUEST, payload);
        if(response.suggestion){
            yield put ({
                type: ActionConstants.FETCH_PARTY_SUGGESTION_SUCCESS,
                payload: response.suggestion
            })
        }
    }
    catch(error){
    }
    finally{
    }  
}

export function* addAssociateParty({payload}){
    try{
        const successCallback = payload.successCallback;
        delete payload.successCallback;
        yield put({ type: ActionConstants.SHOW_PARTIES_LOADER });
        const response = yield call(PUBLIC_API_PARTY.associateParties, payload);
        if(response.status == 200){
            const getItems = (state) => state.workkardDetail;
            const items = yield select(getItems);
            const middlePanelParties = items.middlePanel.parties;
            const partyPayload = {
                actId: items.activityDetail.activityId || 0,
                cId: items.workkardDetail.Id,
                filterOption: middlePanelParties.filter.filterOption,
                skip: 0,
                take: 15,
                sortBy: 1,
                sort: "OPEN",
                type: middlePanelParties.type
            }
            successCallback();

            // yield put ({
            //     type: WorkkardDetailActionConstants.RESET_MIDDLE_PANEL_INDIVIDUAL_TAB_SUCCESS,
            //     payload: { type: 'parties', value: middlePanelParties.type }
            // })

            yield* updatePanelDataPermissionSet({ payload: partyPayload , permission:{isUpdateParties:true}});
        }
        else if(response.status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        }
        else if(response.status==ErrorCode.Fail && response.toastPayload)
        {
           yield put({type:SHOW_TOAST_WITH_PROPS,payload:response.toastPayload});
        } 
        // else if(response.status == 400){
        //     yield put ({
        //         type: ActionConstants.ADD_ASSOCIATE_PARTY_ERROR,
        //         payload: {errorMessage: WorkkardErrorConstant.ADD_ASSOCIATE_PARTY_ERROR[response.status]}
        //       })
        // }
        else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status:response.status, isErrorScreen:false  }
            });
        }
    }
    catch(error){
        getAxiosError(error);
        
            let  errorMsg = error.message.includes("400")?  WorkkardErrorConstant.ADD_ASSOCIATE_PARTY_ERROR[400]: "Something went wrong!";
            yield put ({
             type: ActionConstants.ADD_ASSOCIATE_PARTY_ERROR,
             payload: {errorMessage: errorMsg}
           })
           
    }
    finally{
        yield put({ type: ActionConstants.HIDE_PARTIES_LOADER });
    }
}

export function* deleteAssociateParty({payload}){
    try{
        yield put({ type: ActionConstants.SHOW_PARTIES_LOADER });
        const response = yield call(Api.deleteAssociateParty, ActionConstants.DELETE_ASSOCIATE_PARTY_REQUEST, payload);
        if(response.status == 200){
            yield put({ type: HIDE_DIALOGUE_BOX });
            yield put ({
                type: ActionConstants.DELETE_ASSOCIATE_PARTY_SUCCESS,
                payload: {id: payload.id}
              })
        }
        else if(response.status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status:response.status, isErrorScreen:false  }
            });
        }
    }
    catch(error){
    }
    finally{
        yield put({ type: ActionConstants.HIDE_PARTIES_LOADER });
    }  
}

export function* changeLogAssociateParty({payload}){
    try{
        yield put({ type: ActionConstants.SHOW_PARTIES_LOADER });
        const response = yield call(Api.fetchChangeLog, ActionConstants.CHANGE_LOG_ASSOCIATE_PARTY_REQUEST, payload);
        if(response.status == 200){
            yield put ({
                type: ActionConstants.CHANGE_LOG_ASSOCIATE_PARTY_SUCCESS,
                payload: response.data
            })
        }
        else if(response.status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status:response.status, isErrorScreen:false  }
            });
        }
    }
    catch(error){
    }
    finally{
        yield put({ type: ActionConstants.HIDE_PARTIES_LOADER });
    }  
}

export function* saveAssociatedParty({payload}){
    try{
        yield put({ type: ActionConstants.SHOW_PARTIES_LOADER });
        delete payload.successCallback;
        const response = yield call(AdminApi.saveAssociatedParty, ActionConstants.SAVE_ASSOCIATED_PARTY, payload);
        if(response){
            yield put(savePartySuccess());
            yield put({
                type: SHOW_TOAST_WITH_PROPS,
                payload: { message: "Party created successfully.", type: "success", delayTime: 5000, isCloseIcon: true, autoClose: true },
            });
        } else {
            yield put(savePartyFailure("Failed to create party. Please try again."));
            yield put({
                type: SHOW_TOAST_WITH_PROPS,
                payload: { message: "Failed to create party. Please try again.", type: "error", delayTime: 5000, isCloseIcon: true, autoClose: true },
            });
        }
    }
    catch(error){
        const errorMessage = error?.response?.data?.message || error?.message || "Failed to create party.";
        yield put(savePartyFailure(errorMessage));
        yield put({
            type: SHOW_TOAST_WITH_PROPS,
            payload: { message: errorMessage, type: "error", delayTime: 5000, isCloseIcon: true, autoClose: true },
        });
    }
    finally{
        yield put({ type: ActionConstants.HIDE_PARTIES_LOADER });
    }
}

export function* editAssociatedParty({payload}){
    try{
        yield put({ type: ActionConstants.SHOW_PARTIES_LOADER });
        delete payload.successCallback;
        const response = yield call(AdminApi.editAssociatedParty, ActionConstants.EDIT_PARTY_REQUEST, payload);
        if(response){
            yield put({
                type: ActionConstants.EDIT_PARTY_SUCCESS,
                payload: { editPartyData: response },
            });
            yield put(savePartySuccess());
            yield put({
                type: SHOW_TOAST_WITH_PROPS,
                payload: { message: "Party updated successfully.", type: "success", delayTime: 5000, isCloseIcon: true, autoClose: true },
            });
        } else {
            yield put(savePartyFailure("Failed to update party. Please try again."));
            yield put({
                type: SHOW_TOAST_WITH_PROPS,
                payload: { message: "Failed to update party. Please try again.", type: "error", delayTime: 5000, isCloseIcon: true, autoClose: true },
            });
        }
    }
    catch(error){
        const errorMessage = error?.response?.data?.message || error?.message || "Failed to update party.";
        yield put(savePartyFailure(errorMessage));
        yield put({
            type: SHOW_TOAST_WITH_PROPS,
            payload: { message: errorMessage, type: "error", delayTime: 5000, isCloseIcon: true, autoClose: true },
        });
    }
    finally {
        yield put({ type: ActionConstants.HIDE_PARTIES_LOADER });
    }
}

export default [
    takeLatest(ActionConstants.FETCH_ASSOCIATED_PARTIES_DATA_REQUEST, fetchAssocitedPartiesData),
    takeLatest(ActionConstants.UPDATE_ASSOCIATED_PARTIES_DATA_REQUEST,updateAssocitedPartiesData),
    takeLatest(ActionConstants.FETCH_CREATE_PARTY_DATA_REQUEST, fetchCreatePartyData),
    takeLatest(ActionConstants.FETCH_PARTY_INFO_REQUEST, fetchPartyInfo),
    takeLatest(ActionConstants.FETCH_PARTY_SUGGESTION_REQUEST, fetchPartySuggestions),
    takeLatest(ActionConstants.ADD_ASSOCIATE_PARTY_REQUEST,addAssociateParty),
    takeLatest(ActionConstants.DELETE_ASSOCIATE_PARTY_REQUEST,deleteAssociateParty),
    takeLatest(ActionConstants.CHANGE_LOG_ASSOCIATE_PARTY_REQUEST,changeLogAssociateParty),
    takeLatest(ActionConstants.SAVE_ASSOCIATED_PARTY,saveAssociatedParty),
    takeLatest(ActionConstants.EDIT_PARTY_REQUEST, editAssociatedParty),
    takeLatest(ActionConstants.FETCH_PARTY_STATES_REQUEST, fetchPartyStates),
    takeLatest(ActionConstants.UPDATE_CONTACT_RELATIONSHIP_REQUEST,updateContactRelationshipType),
    takeLatest(ActionConstants.FETCH_CARRIER_LIST, fetchCarrierList)
];
  
